import { render } from "./BeerTwo.vue?vue&type=template&id=0869e515"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/BeerTwo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0869e515"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0869e515', __exports__)) {
    api.reload('0869e515', __exports__)
  }
  
  module.hot.accept("./BeerTwo.vue?vue&type=template&id=0869e515", () => {
    api.rerender('0869e515', render)
  })

}


export default __exports__